export default __webpack_public_path__ + "static/media/shopify.a3ea7712.svg";